module.exports = __webpack_public_path__ + "static/img/template-badge.e17b877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/template-badge.png
// module id = 458
// module chunks = 4